import YoutubeVideo, {
  Props as YoutubeVideoProps,
} from "components/YoutubeVideo";
import { Overlay } from "iparque-components";
import React from "react";

interface Props extends YoutubeVideoProps {
  visible: boolean;
  onClose: () => void;
}

const VideoOverlay: React.FC<Props> = ({
  visible,
  onClose,
  ...youtubeVideoProps
}) => {
  return (
    <Overlay visible={visible} onClose={onClose}>
      <YoutubeVideo {...youtubeVideoProps} />
    </Overlay>
  );
};

export default VideoOverlay;
